export { default } from "./appStyledTemplate";
